export default {
      id: "bulle_demarche_menu-usage",
      viewBox: "0 0 220 90",
      url: "../dist/images/" + "sprite.svg#bulle_demarche_menu-usage",
      toString: function () {
        return this.url;
      }
    }